<template>
  <div class="author" v-cloak>
  </div>
</template>

<script>
import Vue from "vue";
import config from "@/common/environment.js";
const redirect_uri = encodeURIComponent(config.REDIRECT_URI);
const appid = config.APPID;
export default {
  name: "indexA",
  data() {
    return {};
  },
  mounted() {
    this.$toast.loading();
    let urlJson = this.parseToJson(location.href),
      code = "";
    if (urlJson) {
      code = urlJson.code;
      // Lockr.set("openId", openId);
    }
    if (!code) {
      console.log(code, "没有code");
      this.wechatGetAuthorize();
    } else {
      console.log(code, "条页面");

      this.getCodeUserInfo(code);
    }
  },
  methods: {
    wechatGetAuthorize() {
      let localRoute =  '';
      if (this.$route.query.machineId) {
        Lockr.set("machine_id", this.$route.query.machineId);
      }
      if (this.$route.query.invite_code) {
        Lockr.set("invite_code", this.$route.query.invite_code);
        localRoute = this.$route.query.invite_code;
      }else{
        localRoute = '123456';
      }

      // this.$get('/member/api/WxMp/BaseAuthUrl',)
      //   .then(({ data }) => {
      //     // console.log(data.data)
      //     window.location.href = data.data.redirectUrl;
      //   }); 
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${localRoute}#wechat_redirect`;
    },

    parseToJson(url) {
      if (url != "" && url.indexOf("?") != -1) {
        let url_json = {};
        url = url.replace("#/author", "");
        url = url.split("?");
        url = url[1].split("&");
        for (let i = 0; i < url.length; i++) {
          let str = url[i].split("=");
          url_json[str[0]] = str[1];
        }
        return url_json;
      } else {
        return "";
      }
    },
    getCodeUserInfo(code) {
      let _this = this;
      let data = {
        code: code, //为 snsapi_userinfo
        type: 1, //=0 只获取openid返回 1= 判断会员知否存在，不存在则注册
        machine_id: Lockr.get("machineId") || '', //设备id，扫码设备获得
        invite_code: Lockr.get("invite_code") || '', //邀请码
      };
      _this.$post("/api/openid", data, data).then((res) => {
        console.log(res.data, "用户信息");
        if (res.data && res.data.code == 0) {
          Lockr.set("openId", res.data.data.open_id);
          // Lockr.set("userId", res.data.data.user_id); // uid
          // Lockr.set("userInfo", res.data.data); //用户信息
          // Lockr.set("mobile", res.data.data.phone_no); // 手机号
          // this.$store.commit("set_Mobile", res.data.data.phone_no);
          this.$store.commit("setOpenId", res.data.data.open_id);

          let beforeLoginUrl = JSON.parse(Lockr.get("beforeLoginUrl"));
          if (beforeLoginUrl) {
            _this.getUserInfo({
              name: beforeLoginUrl.name,
              query: beforeLoginUrl.query,
              params: beforeLoginUrl.params,
            });
            // this.$router.replace({
            //   name: beforeLoginUrl.name,
            //   query: beforeLoginUrl.query,
            //   params: beforeLoginUrl.params,
            // });
          } else {
            _this.getUserInfo({
              name: "index",
              query: {},
            });
            // this.$router.replace({
            //   name: "index",
            //   query: {},
            // });
          }
        } else if (res.data.code == -120) {
          _this.$dialog
            .alert({
              message: "为了您的使用体验， \n 请先关注公众号!",
              confirmButtonText: "去关注",
              confirmButtonColor: "#2998FF",
            })
            .then(() => {
              // on close
              this.$router.replace({
                name: "wechart-qrcode",
                query: {},
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" scoped>
.author {
  height: 100%;
  width: 100%;
  // background-color: #f9f9f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes heartbeat {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
